export default "__VITE_ASSET__DrOTXHgt__"